import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
/**
 * GameEvent.ts
 */
export class GameEvent {
}
GameEvent.FEATURE_DIALOG_REQUEST = new EventObject("GameEvent.FEATURE_DIALOG_REQUEST");
GameEvent.HELP_HIDE_BASEGAME = new EventObject("GameEvent.HELP_HIDE_BASEGAME");
GameEvent.HELP_SHOW_BASEGAME = new EventObject("GameEvent.HELP_SHOW_BASEGAME");
GameEvent.FORCE_COLLECT = new EventObject("GameEvent.FORCE_COLLECT");
GameEvent.FEATURE_REQUEST = new EventObject("GameEvent.FEATURE_REQUEST");
GameEvent.FEATURE_START = new EventObject("GameEvent.FEATURE_START");
GameEvent.FEATURE_END = new EventObject("GameEvent.FEATURE_END");
GameEvent.COIN_WIN_ANIMATION = new EventObject("GameEvent.COIN_WIN_ANIMATION");
GameEvent.COIN_WIN_UPDATE_TOTAL = new EventObject("GameEvent.COIN_WIN_UPDATE_TOTAL");
GameEvent.COIN_WIN_COMPLETE = new EventObject("GameEvent.COIN_WIN_COMPLETE");
GameEvent.WIN_LINE_SUSPENSE = new EventObject("GameEvent.WIN_LINE_SUSPENSE");
GameEvent.WIN_LINE_COMPLETE = new EventObject("GameEvent.WIN_LINE_COMPLETE");
GameEvent.WIN_LINE_ANIMATION = new EventObject("GameEvent.WIN_LINE_ANIMATION");
GameEvent.WIN_LINE_FIREWORKS_COMPLETE = new EventObject("GameEvent.WIN_LINE_FIREWORKS_COMPLETE");
GameEvent.SCATTER_WIN_COLLECT = new EventObject("GameEvent.SCATTER_WIN_COLLECT");
GameEvent.SCATTER_WIN_SUSPENSE = new EventObject("GameEvent.SCATTER_SUSPENSE");
GameEvent.SCATTER_WIN_SUSPENSE_STOP = new EventObject("GameEvent.SCATTER_SUSPENSE_STOP");
GameEvent.SCATTER_WIN_SUSPENSE_CANCELLED = new EventObject("GameEvent.SCATTER_WIN_SUSPENSE_CANCELLED");
GameEvent.NEXT_GAME_TRANSITION = new EventObject("GameEvent.NEXT_GAME_TRANSITION");
GameEvent.WILD_PARTICLE_FEATURE_COMPLETE = new EventObject("GameEvent.WILD_PARTICLE_FEATURE_COMPLETE");
GameEvent.AWARD_FREE_SPINS = new EventObject("GameEvent.AWARD_FREE_SPINS");
GameEvent.RECOVER_REEL_SYMBOLS = new EventObject("GameEvent.RECOVER_REEL_SYMBOLS");
export class FreeSpinsOverlayViewEvent {
}
FreeSpinsOverlayViewEvent.TRIGGER_COLLECTION = new EventObject("FreeSpinsOverlayViewEvent.TRIGGER_COLLECTION");
FreeSpinsOverlayViewEvent.COLLECTION_COMPLETE = new EventObject("FreeSpinsOverlayViewEvent.COLLECTION_COMPLETE");
export class ScatterPickEvent {
}
ScatterPickEvent.TRANSITION_IN = new EventObject("ScatterPickEvent.TRANSITION_IN");
ScatterPickEvent.PICK_REQUEST = new EventObject("ScatterPickEvent.PICK_REQUEST");
ScatterPickEvent.PICK_RESPONSE = new EventObject("ScatterPickEvent.PICK_RESPONSE");
ScatterPickEvent.PICK_RESULT = new EventObject("ScatterPickEvent.PICK_RESULT");
ScatterPickEvent.TRANSITION_OUT = new EventObject("ScatterPickEvent.TRANSITION_OUT");
ScatterPickEvent.BACKGROUND_OUT = new EventObject("ScatterPickEvent.BACKGROUND_OUT");
ScatterPickEvent.COCONUT_FLASH = new EventObject("ScatterPickEvent.COCONUT_FLASH");
export class GameTestEvent {
}
GameTestEvent.TOTAL_WIN_UPDATE = new EventObject("GameTestEvent.TOTAL_WIN_UPDATE");
GameTestEvent.FREE_SPIN_OVERLAY = new EventObject("GameTestEvent.FREE_SPIN_OVERLAY");
GameTestEvent.TRIGGER_WILD_PARTICLES = new EventObject("GameTestEvent.TRIGGER_WILD_PARTICLES");
//# sourceMappingURL=GameEvent.js.map